import React from "react";
import { useLocation } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import * as Icons from "assets/icons";

import config from "config";

import Container from "components/Container";

import cls from "./Header.module.scss";
import LanguageSelect from "./components/LanguageSelect";

const Header = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const linkClassName = ({ isActive }) =>
    `${cls.siteName} ${isActive ? cls.active : ""}`;

  return (
    <header
      className={cx(
        cls.header,
        location.pathname !== "/" &&
          location.pathname !== "/service-register" &&
          location.pathname !== "/mandatory-requirement/register" &&
          cls["header-static"],
      )}>
      <Container>
        <div className={cls.content}>
          <div className={cls.left}>
            <Link className={cls.logo} to="/">
              <Icons.Logo size={40} />

              <span className={cls.name}>
                O’zbekiston Respublikasi <br /> Adliya vazirligi
              </span>
            </Link>
          </div>
          <nav className={cls.nav}>
            <NavLink className={linkClassName} to="/">
              {t("register_of_state_functions")}
            </NavLink>
            {/* <span className={cls.line} /> */}
            <NavLink className={linkClassName} to="/service-register">
              {t("register_of_state_services")}
            </NavLink>
            {/* <span className={cls.line} /> */}
            <NavLink
              className={linkClassName}
              to="/mandatory-requirement/register">
              {t("mandatory-requirements")}
            </NavLink>
          </nav>

          <div className={cls.right}>
            <LanguageSelect />
            <a
              className={cls.enter}
              rel="noreferrer"
              href={config.app.partner_url}
              target="_blank">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 10.2664L13.7071 11.5593C13.3166 11.9498 13.3166 12.5829 13.7071 12.9735L15 14.2664M14 12.2664L20 12.2664M4 17.2663V7.26633M16 17.2663C16 18.3709 15.1046 19.2663 14 19.2663H10M16 7.26633C16 6.16176 15.1046 5.26633 14 5.26633H10M4.8906 19.8601L6.8906 21.1934C8.21971 22.0795 10 21.1267 10 19.5293V5.00336C10 3.40597 8.21971 2.45319 6.8906 3.33926L4.8906 4.6726C4.3342 5.04353 4 5.66799 4 6.3367V18.196C4 18.8647 4.3342 19.4891 4.8906 19.8601Z"
                  stroke="#737687"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              <span>{t("action_enter")}</span>
            </a>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
